import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!

  return (_openBlock(), _createBlock(_component_CustomSelect, {
    modelValue: _ctx.internalSelectedCountry,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSelectedCountry) = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', $event)))
    ],
    items: _ctx.countriesListItems,
    displaySearch: true,
    placeholder: "Select country",
    class: "select-country",
    "onUpdate:query": _ctx.filterCountriesListItems
  }, null, 8, ["modelValue", "items", "onUpdate:query"]))
}